import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Api from './Api';

function SSoft_Solutions_Slider() {
  const activeLang = useSelector((state) => state.content.activeLanguage);
  const [sectionItems, setSectionItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const sectionData = sectionResponse.data.results[0]?.widgets[0]?.widget_contents;

      setSectionItems(sectionData);
    };

    fetchData();
  }, [activeLang]);

  const splideOptions = {
    type: 'loop',
    perPage: 3,
    focus: 'center',
    autoplay: true,
    speed: 800,
    rewindSpeed: 800,
    interval: 5000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    breakpoints: {
      1800: {
        perPage: 2,
        gap: '30px'
      },
      576: {
        perPage: 1,
        // autoplay: true,
      }
    }
  };

  return (sectionItems && sectionItems.length > 0) && (
    <div className='w-full max-h-[565px] mt-[60px] md:mt-[80px] mb-[20px]'>
      <Splide className="" options={splideOptions}>
        {
          sectionItems.map((item) => (
            <SplideSlide key={item.id}>
              <img className='w-full block border rounded-lg scale-75 transition-transform duration-500' src={item?.file_medium} alt={item?.description} />
            </SplideSlide>
          ))
        }
      </Splide>
    </div>
  )
}

export default SSoft_Solutions_Slider;